<template>
  <el-container
    style="width: 100%; max-width: 1500px; margin: 0 auto;"
    v-loading="loading"
  >
    <el-header>
      <router-view
        name="menu"
        v-if="user && !loading"
      />
    </el-header>
    <el-main>
      <router-view v-if="!loading"/>
    </el-main>
  </el-container>
</template>

<script>
import LogRocket from 'logrocket';

export default {
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    token() {
      return this.$store.getters['auth/token'];
    }
  },
  async mounted() {
    this.loading = true;
    if (this.token && !this.user) {
      try {
        await this.$store.dispatch('auth/fetchUser');
      } catch (e) {
        this.$store.commit('auth/removeToken');
        this.$router.push({ name: 'login' });
      }
    }
    if (this.user) {
      LogRocket.identify(this.user.id, {
        name: `${this.user.first_name} ${this.user.last_name}`,
        email: this.user.email,
      });
    }
    this.loading = false;
  },
};
</script>

<style lang="scss">
  @import "~element-ui/lib/theme-chalk/index.css";

  html {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .el-form.el-form--label-top .el-form-item__label {
    margin-bottom: 0;
    line-height: 1;
  }
</style>
